// @flow
import React from 'react';

import type { Node as ReactNode } from 'react';

import './style.pcss';

type Props = {
  children: ReactNode
}

const List = ({ children }: Props) => (
  <div className='ui-site-list'>
    <ul className='ui-site-list__wrapper'>
      {children}
    </ul>
  </div>
);

const ListItem = ({ children }: Props) => (
  <li className='ui-site-list__item'>
    {children}
  </li>
);

export { List as default, List, ListItem };
